export default {
  loginDetails: "login-details",
  batchId: "batch-id",
  userId: "id",
  token: "token",
};
